import queryString from 'query-string';

export default function(query, isAdvancedSearchResults) {
    let urlTabs = '';
    delete query.area;
    delete query.q;
    delete query.tab;
    delete query.ipp;
    delete query.sorting;
    delete query.page;

    if (!isAdvancedSearchResults) {
        for (let key in query) {
            let index = Object.keys(query).indexOf(key);
            if (index !== 0) {
                urlTabs += '&';
            }
            urlTabs += queryString.stringify({[`${key}`]: query[key]}, {arrayFormat: 'index'});
        }
    }

    if (isAdvancedSearchResults) {
        for (let key in query) {
            urlTabs += key + '=' + query[key];
        }
    }

    urlTabs = urlTabs ? isAdvancedSearchResults ? `%26${encodeURIComponent(urlTabs)}` : `/${encodeURIComponent(urlTabs)}` : '';
    return urlTabs;
};



// WEBPACK FOOTER //
// ./src/scripts/ResultsQueryParse.js